import update from 'immutability-helper';
import Store from '../../interfaces/Store';
import { Notification, NotificationType } from '../../interfaces/Notification';

export const addNotificationsReducer = (state: Store, notifications: Notification[]): Store => {
  const hasSelectionNotification = notifications.some(
    (notification) => notification.type === NotificationType.MESSAGE_WITH_SELECTION,
  );

  if (!hasSelectionNotification) {
    return update(state, {
      notifications: {
        $push: notifications,
      },
    });
  }

  const notificationsWithoutSelections = state.notifications.filter(
    (notification) => notification.type !== NotificationType.MESSAGE_WITH_SELECTION,
  );

  return update(state, {
    notifications: {
      $set: [...notificationsWithoutSelections, ...notifications],
    },
  });
};

export const removeNotificationReducer = (state: Store, notificationId: string): Store =>
  update(state, {
    notifications: {
      $set: state.notifications.filter((n) => n.id !== notificationId),
    },
  });
